import React, {useEffect, useState} from 'react';
import AuthContext from "./authContext";
import axios from "axios";
import cookie from "../utils/cookie";
import {useLocation, useNavigate} from "react-router-dom";
import localized from "../i18n";
import {getParams} from "../utils/params";


const AuthProvider = ({children}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const language = localStorage.getItem("lang");
    const [state,setState] = useState({
        auth:{},
        isAuthenticated:false,
        isSubmitting:false,
        lang: localStorage.getItem('lang') || 'en',
        total:{active:0, inActive:0},
        filter:""
    });

    useEffect(()=> {
        if (["/login","/signup"].indexOf(location.pathname) !== -1 && getParams("lang")){
            const lang = getParams("lang") || "en";
            updateAuth({lang: lang});
            localized.setLanguage(lang);
        } else {
            updateAuth({lang: language || state.lang});
            localized.setLanguage(language || state.lang);
        }
    },[localized.getLanguage() !== language]);

    const getAuthenticatedUser = (isAfterLogin = true) => {
        return axios.get('/api/me')
            .then((response)=>{
                updateAuth({auth:response.data.data,isAuthenticated:true});
                if (isAfterLogin) {
                    setTimeout(() => {
                        getAuthenticatedUser();
                    }, 10000);
                } else {
                    if (response.data.data.role === 1){
                        navigate("/admin-dashboard");
                    }
                    if (response.data.data.role === 2){
                        if (response.data.data && !Boolean(response.data.data.terms_accepted)) {
                            navigate("/tnc-accept");
                        } else {
                            navigate("/dashboard");
                        }
                    }
                }
            }).catch((err) => {
                logout();
            })
    }

    const toggleSubmitting = (response = false) => {
        setState((prev)=>({
            ...prev,
            isSubmitting:response
        }))
    }

    const logout = (user = false) => {
        if (user) {
            toggleSubmitting(true);
            axios.post("/api/logout",{})
                .then((response)=>{
                    toggleSubmitting(false);
                    revokeAccess();
                }).catch((err)=>{
                    toggleSubmitting(false);
                })
        } else {
            revokeAccess();
        }
    }

    const revokeAccess = () => {
        updateAuth({auth: {},isAuthenticated:false});
        cookie.delete('jwt', '/');
        setTimeout(() => {
            navigate('/login');
        }, 100);
    }

    const updateAuth = (value = {}) => {
        setState((prev)=>({
            ...prev, ...value
        }))
    }

    const values = {state,updateAuth,getAuthenticatedUser,logout,toggleSubmitting};
    return (
        <AuthContext.Provider value={values}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;